<template>
  <div class="form-group phone-with-country-code">
    <VueTelInput
      :default-country="country"
      :dropdown-options="{
        'showDialCodeInList':true,
        'showDialCodeInSelection':false,
        'showFlags':true,
        'showSearchBox':true,
      }"
      :input-options="{
        'autofocus':true,
        'showDialCode':true,
        'placeholder':'+54 9 11 3288 4589',
        'required':true,
      }"
      :mode="'international'"
      :valid-characters-only="true"
      @validate="validatePhoneNumber"
      @open="open=true"
      @close="open=false"
    >
      <template v-slot:arrow-icon>
        <span>{{ open ? '▲' : '▼' }}</span>
      </template>
    </VueTelInput>
    <i
      :class="userPhoneIcon"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'PhoneInput',

  components: { VueTelInput },
  props: {
    country: {
      type: String,
      required: false,
      defaults: '',
    },
  },

  data() {
    return {
      userPhoneIcon: null,
      userPhone: {
        telephone_cc: '',
        telephone: '',
      },
      open: false,
    };
  },

  methods: {
    validatePhoneNumber(phoneObject) {
      if (phoneObject.valid) {
        this.userPhone.telephone = phoneObject.nationalNumber;
        this.userPhone.telephone_cc = phoneObject.countryCallingCode;
        this.userPhoneIcon = 'icon-check-1 text-success';
        this.bookErrors = {};
        this.$emit('phoneUpdated', this.userPhone);
      } else {
        this.userPhone.telephone = null;
        this.userPhone.telephone_cc = null;
        this.userPhoneIcon = 'icon-cancel-1 text-danger';
      }
    },
  },
};
</script>

<style scoped>

</style>
